import { AddressID } from 'framework/address'
import { OrderID } from 'framework/orders'
import EcommerceService from 'services/ecommerce-service'

export default class OrderAddressService extends EcommerceService {
  update(orderId: OrderID, newShippingValue: number, addressId: AddressID) {
    const payload = {
      address_id: addressId,
      total_shipping: parseFloat(newShippingValue.toFixed(2)),
    }

    const url = `/orders/${orderId}/delivery-address-update`
    const req = this.setUrl(url).post(payload)
    return req
  }
}
